import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=10debb61"
import script from "./not-found.ts?vue&type=script&lang=ts&external"
export * from "./not-found.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports